import { Field as IField } from "@/core/types/types";
import Field from "../../Field";
import { Theme, Box, SxProps } from "@mui/material";
import useCustomStyles from "@/core/hooks/useCustomStyles/useCustomStyles";

const styles = (theme: Theme) => ({
  root: {
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "row-reverse",
    marginTop: theme.spacing(5),
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      marginTop: theme.spacing(2),
    },
    "& div": {
      margin: theme.spacing(0, 0, 0, 2),
      [theme.breakpoints.down("md")]: {
        margin: theme.spacing(0, 0, 1),
      },
    },
  },
  fullWidth: {
    flexDirection: "column",
    "& > div": {
      marginTop: 0,
    },
    "& div": {
      margin: theme.spacing(2, 0, 0, 0),
    },
    "& button": {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      maxWidth: "456px",
      margin: "auto",
      padding: `${theme.spacing(1, 4)} !important`,
      height: "auto !important",
      minHeight: "40px !important",
      ":has(.subtext)": {
        fontWeight: "bold",
        lineHeight: 1.3,
        "& .subtext": {
          fontWeight: "normal",
          fontSize: "14px",
          lineHeight: 1.2,
        },
      },
    },
  },
});

interface NavigationProps {
  buttons: IField[];
}

const NavigationButtons = ({ buttons }: NavigationProps) => {
  const classes: any = useCustomStyles(styles);
  const isFullWidth: boolean = buttons.some(
    (field: IField) => !!field.properties?.fullWidth
  );
  const buttonsStyleProps: SxProps = isFullWidth
    ? {
        ...classes?.root,
        ...classes?.fullWidth,
      }
    : {
        ...classes?.root,
      };

  return (
    <Box sx={buttonsStyleProps}>
      {buttons.map((field: any) => {
        return (
          <div key={field.id}>
            <Field field={field} />
          </div>
        );
      })}
    </Box>
  );
};

export default NavigationButtons;
